@if (isPageInitialized) {
  <ng-container *transloco="let t; prefix: 'workOrder'">
  <div
    class="dashboard-top-section d-flex align-items-center justify-content-between">
    <h1>{{ t('title') }}</h1>

    <div class="d-flex gap-2 align-items-center">
      <app-account-filter
        [filter]="accountFilter"
        (filterChanged)="onAccountFilterChange($event)">
      </app-account-filter>

      <!-- Action Buttons -->
      <button
        class="btn btn-secondary action-button"
        (click)="openWorkshopCalendar()">
        <span>{{ t('actions.workshopCalendar') }}</span>
      </button>

      @if (activeTab === 'requests') {
        <button
          class="btn btn-secondary action-button"
          [disabled]="!requestsOverview?.hasSelection()"
          (click)="bulkApprove()">
          <span>{{ t('actions.bulkApprove') }}</span>
        </button>
      }

      <button
        class="btn btn-primary create-button"
        (click)="openCreateWorkOrder()">
        <span>{{ t('actions.createWorkOrder') }}</span>
      </button>
    </div>
  </div>

  <!-- Tabs -->
  <div class="tabs-container w-100">
    <button
      class="tab-button"
      [class.active]="activeTab === 'requests'"
      (click)="onTabChange('requests')">
      {{ t('tabs.requests') }}
    </button>
    <button
      class="tab-button"
      [class.active]="activeTab === 'work-orders'"
      (click)="onTabChange('work-orders')">
      {{ t('tabs.workOrders') }}
    </button>
  </div>

  <!-- Work Order Requests Table -->
  @if (activeTab === 'requests') {
    <app-work-order-requests-overview
      [currencySymbol]="currencySymbol">
    </app-work-order-requests-overview>
  }

  <!-- Work Orders Overview with KPI Widgets and Table -->
  @if (activeTab === 'work-orders') {
    <app-work-orders-overview
      [currencySymbol]="currencySymbol">
    </app-work-orders-overview>
  }
  </ng-container>
}
